

import React from 'react';
import View from "./view"
import Page from "src/components/Page";
function index(props) {
    // localStorage.removeItem("@storeAuctionLot");

    

    return (
        <>


        <Page >
            <View/>
        </Page>
        </>
    );
}

export default index;